// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wd-custom-ui-component{min-height:50px;padding:20px}.wd-custom-ui-component .data-area-container-wrapper-web{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
